<!--suppress CommaExpressionJS -->
<template>
  <div>
    <div
      v-loading="!currentNavConfig"
      style="height: 100%; text-align: left; background-color: #104079"
      class="di-ding-nav"
    >
      <el-menu
        class="center_left el-menu-vertical-demo"
        :default-active="activeIndex"
        :collapse="isCollapse"
      >
        <template v-for="(item1, index) in currentNavConfig">
          <el-menu-item
            v-if="!item1.sub"
            :index="index.toString()"
            :key="index"
            @click="handleClick(item1.to)"
          >
            <i :class="item1.icon"></i>
            <span slot="title">{{ item1.name }}</span>
          </el-menu-item>
          <el-submenu v-else :index="index.toString()">
            <template slot="title">
              <i :class="item1.icon"></i>
              <span>{{ item1.name }}</span>
            </template>
            <el-menu-item
              v-for="(item, index2) in item1.sub"
              :index="index + '-' + index2"
              class="sub-item"
              @click="handleClick(item.to)"
              :key="item.name + index + index2"
              >{{ item.name }}
            </el-menu-item>
          </el-submenu>
        </template>

      </el-menu>
    </div>
  </div>
</template>

<script>
import { DI_NAME_IN_PARAMS, ROUTE_NAME_OF_DI_PAGE } from "../index";
import { loge } from "../../../../utils/errorHandler";
import bus from "../../../../utils/bus";
import { utils } from "../utils";

export default {
  name: "pay-hall-nav",
  data() {
    return {
      isCollapse: false,
      navConfigs: null,
      loading: true,
      activeIndex: null,
      currentNavConfig: null,
      currentNavItemConfig: null,
    };
  },
  computed: {
    diName() {
      return this.$route.params[DI_NAME_IN_PARAMS];
    },
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    $route() {
      this.render();
    },
  },
  created() {
    this.navConfigs = utils.permissionFilter();
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
    setTimeout(() => {
      this.render();
    });
  },
  methods: {
    render() {
      this.getCurrentNavConfig();
      bus.global.currentNavConfig = this.currentNavConfig;
    },
    getCurrentNavConfig() {
      const ifFindDoSomething = (navItemConfig, navConfig, activeIndex) => {
        if (navItemConfig.to) {
          const { diName, routeName, also = {} } = navItemConfig.to;
          const diNames = [diName].concat(also.diName);
          const routeNames = [routeName].concat(also.routeName);

          if (
            (this.diName && diNames.includes(this.diName)) ||
            (this.routeName && routeNames.includes(this.routeName))
          ) {
            this.currentNavConfig = navConfig;
            this.currentNavItemConfig = navItemConfig;
            setImmediate(() => {
              this.activeIndex = activeIndex;
            });
          }
        }
      };
      this.navConfigs.forEach((navConfig) => {
        navConfig.forEach((navItemConfig, index) => {
          ifFindDoSomething(navItemConfig, navConfig, index.toString());
          if (navItemConfig.sub) {
            navItemConfig.sub.forEach((navItemConfig, index2) => {
              ifFindDoSomething(navItemConfig, navConfig, index + "-" + index2);
            });
          }
        });
      });
    },
    handleClick(to) {
      if (to && to.diName) {
        this.$router.push({
          name: ROUTE_NAME_OF_DI_PAGE.CENTER,
          params: {
            diName: to.diName,
            ...to.params,
          },
        });
        return;
      }

      if (to && to.routeName) {
        this.$router.push({
          name: to.routeName,
          params: to.params,
        });
        return;
      }

      loge(new Error("不支持的跳转操作"));
    },
  },
};
</script>

<style scoped>
/*.el-menu-item {*/
/*border-left: 5px solid #FFFFFF;*/
/*transition: border-color .5s, background-color .5s, color .5s;*/
/*}*/

/*.is-active,*/
/*.el-menu-item:hover {*/
/*border-left: 5px solid #1362FF !important;*/
/*margin-left: 0 !important;*/
/*}*/

/*.sub-item {*/
/*padding-left: 80px !important;*/
/*}*/

/*.is-opened {*/
/*border-left: 0 !important;*/
/*}*/

/*.el-submenu.is-active:not(.is-opened) {*/
/*border-left: 0 !important;*/
/*}*/

/*.el-menu-item:hover,*/
/*.el-menu-item:hover *,*/
/*.el-submenu__title:hover * {*/
/*color: #1362FF !important;*/
/*}*/
</style>

<style lang="less">
/*.pay-hall-table-header {*/
/*th {*/
/*background-color: #EFF1F5 !important;*/
/*color: #48576A;*/
/*.cell {*/
/*text-align: center;*/
/*}*/
/*}*/
/*}*/

/*.el-table__body {*/
/*td {*/
/*.cell {*/
/*text-align: center;*/
/*}*/
/*}*/
/*}*/

.di-ding-nav {
  height: 100%;
  background-color: #fff;
  .el-submenu__title {
    font-size: 14px;
    height: 46px;
    line-height: 46px;
    /*border-left: 5px solid #FFFFFF;*/
    text-align: left;
    background-color: #104079;
    color: #fff;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 220px;
  }
  .el-submenu{
    color: #fff;
  }
  i {
    color: #fff;
  }
  .el-submenu__title {
    /*border-left: 5px solid #FFFFFF;*/
    background-color: #104079;
    text-align: left;
    color: #fff;
  }
  .el-menu-item {
    // border-left: 5px solid blue;
    color: #fff;
    text-align: left;
    background-color: #104079;
    font-size: 14px;
  }
  .el-submenu .el-menu-item {
    text-align: left;
    padding-left: 80px !important;
  }
  .el-menu-item .is-active {
    background-color: red;
  }
  .is-active,
  .el-menu-item:hover {
    // border-left: 5px solid #1362FF !important;
    margin-left: 0 !important;
    background-color: #0c356c;
    /*.el-submenu__title {*/
    /*border-left: 0 !important;*/
    /*}*/
  }
  .is-active,
  .el-menu-item:visited {
    background-color: #0b2045 !important;
  }
  .el-submenu {
    color: #FFFFFF;
    // border-left: 5px solid red;
    :hover {
      margin-left: 0 !important;
      background-color: #0c356c;
    }
  }
  .el-menu {
    border-right: none;
    .sub-item {
      border-left: 0 !important;
    }
  }
}
.di-ding-nav .el-menu-item-group .el-menu-item,
.left_nav .el-menu-item-group .el-menu-item:hover,
.left_nav .el-menu-item-group .is-active {
  border-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/di-ding/pages/nav.vue